import { successToast } from "./success";
export const ToastClasses =
  "border-2 dark:bg-dark-2 dark:border-dark-3 dark:text-slate-300 text-sm";
export { successToast };
